import { render } from "./EspacoForm.vue?vue&type=template&id=aa5b82a4&scoped=true"
import script from "./EspacoForm.vue?vue&type=script&lang=js"
export * from "./EspacoForm.vue?vue&type=script&lang=js"

import "./EspacoForm.vue?vue&type=style&index=0&id=aa5b82a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa5b82a4"]])

export default __exports__